import moment from 'moment';

export const GUID_VIDE = '00000000-0000-0000-0000-000000000000';
export const INFINITE_DAY = new Date(2700, 12, 1);
export const MODE_CALCUL_MANUEL = 'Manuel';
export const INFINITE_DAY_AFF = new Date(2099, 12, 1);
export const DATE_MIN = moment('2000-01-01');



// WEBPACK FOOTER //
// ./src/configuration/general.js